import { useParams } from 'react-router-dom';

import { useCurrentUser, useView } from '@/hooks';

import type { SurveyTemplate } from '@/types';

import { useGetSurveyTemplateQuery } from '@/store/api/surveyApi';

export const useSurveyTemplate = () => {
  const { templateId = '' } = useParams();
  const { isUserLoading } = useCurrentUser();
  const { isCoach, isViewLoading } = useView();

  const {
    data: surveyTemplate = {} as SurveyTemplate,
    isLoading: isSurveyTemplateLoading,
    refetch: refetchSurveyTemplate,
  } = useGetSurveyTemplateQuery(
    {
      templateId,
    },
    // Skip querying until we have a templateId and required context
    { skip: isUserLoading || (isCoach && isViewLoading) || !templateId },
  );

  return {
    isSurveyTemplateLoading,
    refetchSurveyTemplate,
    surveyTemplate,
  };
};
